<template>
  <div>
    <div v-if="isLoading" test-id="isLoading">
      <div class="flex items-center justify-center w-full h-screen -mt-32">
        <spinner />
      </div>
    </div>
    <!--table-->
    <div
      v-else-if="!hasNoVirtualAccount"
      class="table-wrapper w-full overflow-x-auto"
    >
      <el-table
        class="relative cursor-pointer font-normal text-root-2 text-xs lg:text-sm"
        max-height="500"
        style="width: 100%"
        :data="tableData"
        @row-click="openCustomerVirtualAccountDetailsDrawer"
      >
        <el-table-column>
          <template slot="header">
            <div
              class="flex items-center justify-between py-2 px-2 lg:px-5 font-semibold"
            >
              <p
                style="word-break: normal"
                class="text-root-2 text-xs lg:text-sm"
              >
                Currency
              </p>
              <el-tooltip content="Sort" placement="top" effect="light">
                <div class="ml-2">
                  <sort-icon :sortDirection="sortDirection" />
                </div>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="flex items-center px-2 lg:px-5 gap-x-3">
              <currency-icons
                :currency="getCurrencyCountry(scope.row.currency)"
              />
              <p
                style="word-break: normal"
                class="text-root-4 font-normal text-xs lg:text-sm"
              >
                {{ scope.row.currency || '--' }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            <p
              style="word-break: normal"
              class="text-root-2 text-xs lg:text-sm"
            >
              Account Name
            </p>
          </template>
          <template slot-scope="scope">
            <p
              class="text-root-2 text-xs lg:text-sm font-normal text-justify px-2 lg:px-5"
              style="word-break: normal"
            >
              {{ scope.row.accountDetails.account_name || '--' }}
            </p>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            <div
              class="flex items-center justify-between py-2 px-2 lg:px-5 font-semibold"
            >
              <p
                style="word-break: normal"
                class="text-root-2 text-xs lg:text-sm"
              >
                Account Number
              </p>
              <el-tooltip content="Sort" placement="top" effect="light">
                <div class="ml-2">
                  <sort-icon :sortDirection="sortDirection" />
                </div>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="text-justify pl-5 font-normal">
              {{ scope.row.accountDetails.account_number || '--' }}
            </div>
          </template>
        </el-table-column>
        <!-- to uncomment when BE updates the endpoint to have status -->
        <!-- <el-table-column width="200">
          <template slot="header">
            <div class="font-semibold flex items-center lg:pl-5">
              <p
                style="word-break: normal"
                class="text-root-2 text-center text-xs lg:text-sm"
              >
                Status
              </p>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="text-xs flex items-start font-normal ml-4 capitalize">
              <div
                :class="statusClass(scope.row.status)"
                class="py-1.5 px-3 rounded-lg flex items-center gap-1"
              >
                {{ formatServerName(scope.row.status) }}
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column>
          <template slot="header">
            <div class="flex items-center lg:px-5 font-semibold">
              <p
                style="word-break: normal"
                class="text-root-2 text-xs lg:text-sm"
              >
                Date Created
              </p>
              <el-tooltip content="Sort" placement="top" effect="light">
                <div class="ml-2">
                  <sort-icon :sortDirection="sortDirection" />
                </div>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <div
              class="flex items-center justify-between py-2 px-2 lg:px-5 font-normal text-xs lg:text-sm"
            >
              <el-tooltip
                :content="tooltipDateContent(scope.row.createdAt)"
                placement="top"
                effect="light"
              >
                <span class="capitalize">{{
                  parseRelativeTime(scope.row.createdAt)
                }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="50">
          <template slot="header"> </template>
          <template slot-scope="">
            <arrow-right-icon />
          </template>
        </el-table-column>
      </el-table>
      <div
        class="flex flex-col md:flex-row gap-2 justify-between md:items-center pt-4"
      >
        <pagination-details
          :page-size="page.size"
          :current-page="page.page"
          :total-count="page.totalCount"
        />
        <el-pagination
          @current-change="handleCurrentChange"
          @prev-click="previous"
          @next-click="next"
          :page-size="page.size"
          :current-page="page.page"
          :total="page.totalCount"
          layout="prev, pager, next"
          hide-on-single-page
          background
        >
        </el-pagination>
      </div>
    </div>
    <transaction-empty-state test-id="emptyState" v-else>
      <h3 class="font-semibold text-lg lg:text-xl my-1.5">
        No virtual account created
      </h3>
      <p class="font-light text-xs lg:text-sm md:text-base">
        Your virtual accounts shows here
      </p>
    </transaction-empty-state>
    <!-- drawer -->
    <div>
      <virtual-account-details-drawer
        v-if="showVirtualAccountDrawer"
        :showDrawer="showVirtualAccountDrawer"
        :virtualAccountDetails="virtualAccountDetails"
        @closeDrawer="closeVirtualAccountDetailsDrawer"
      />
    </div>
  </div>
</template>
<script>
import {
  GetCurrencyCountry,
  StatusClass,
  FormatServerName,
  ParseRelativeTime
} from '@/utils/helpers.js'
import app from '@/mixins/app.js'

export default {
  mixins: [app],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableType: {
      type: String,
      default: () => ''
    },
    page: {
      type: Object,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      sortDirection: 'up',
      showVirtualAccountDrawer: false,
      virtualAccountDetails: {}
    }
  },
  methods: {
    parseRelativeTime (time) {
      return ParseRelativeTime(time)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    statusClass (status) {
      return StatusClass(status)
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    openCustomerVirtualAccountDetailsDrawer (row) {
      this.virtualAccountDetails = row
      this.showVirtualAccountDrawer = true
    },
    closeVirtualAccountDetailsDrawer () {
      this.showVirtualAccountDrawer = false
    },
    handleCurrentChange (val) {
      this.payload.page = val
    },
    next () {
      this.payload.page++
    },
    previous () {
      this.payload.page--
    }
  },
  computed: {
    hasNoVirtualAccount () {
      return this.tableData.length === 0
    }
  },
  components: {
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    TransactionEmptyState: () =>
      import('@/components/v2/bulkPayout/layouts/TransactionEmptyState.vue'),
    SortIcon: () => import('@/assets/v2/icons/SortIcon.vue'),
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    PaginationDetails: () =>
      import('@/components/v2/app/PaginationDetails.vue'),
    VirtualAccountDetailsDrawer: () =>
      import(
        '@/components/v2/externalApi/drawers/VirtualAccountDetailsDrawer.vue'
      ),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  }
}
</script>
